<template>
  <div class="form-stepper">
    <svg class="form-stepper__svg" :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" xmlns="http://www.w3.org/2000/svg">
      <circle class="form-stepper__track" :cx="center" :cy="center" :r="radius" fill="none" :stroke-width="strokeWidth" />
      <circle
        class="form-stepper__value"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        :transform="`rotate(-90 ${center} ${center})`"
      />
      <text class="form-stepper__count" :x="center" :y="center" text-anchor="middle" dominant-baseline="middle">
        {{ stepIdx + 1 }}/{{ stepsCount }}
      </text>
    </svg>
    <div class="form-stepper__content">
      <div class="form-stepper__title">
        {{ currentStep.title }}
      </div>

      <div v-if="currentStep.description" class="form-stepper__description">
        {{ currentStep.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProgress',
  props: {
    currentStep: {
      type: Object,
      required: true,
    },
    stepIdx: {
      type: Number,
      default: 0,
    },
    stepsCount: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 66,
    },
    strokeWidth: {
      type: Number,
      default: 6.6,
    },
  },
  computed: {
    center() {
      return this.size / 2
    },
    radius() {
      return (this.size - this.strokeWidth) / 2
    },
    circumference() {
      return 2 * Math.PI * this.radius
    },
    progress() {
      if (this.stepsCount <= 1) {
        return 1
      }

      return (this.stepIdx + 1) / this.stepsCount
    },
    dashOffset() {
      return this.circumference * (1 - this.progress)
    },
  },
}
</script>

<style lang="sass">
.form-stepper
  display: flex
  align-items: center
  gap: 16px
  margin-bottom: 32px

  &__count
    font-size: 19px
    fill: var(--field-text-color)

  &__title
    font-weight: 700

  &__description
    margin-top: 4px
    opacity: .8

  &__track
    stroke: var(--form-stepper-track-color, #33C0CA)

  &__value
    stroke: var(--form-stepper-value-color, #99DFE5)
    stroke-linecap: butt
    transition: stroke-dashoffset .3s ease
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/components/FormStepper.vue